
/**
 * Gets the distance to the edge of the map viewport
 *
 * @param {google.maps.Map} map - the map object whose viewport size we want
 * @param {Boolean} eastBorder - whether to compute the east or north edge
 * @return {Number} Distance in meters
 */

export default (map, eastBorder = true) => {
  try {
    const center = map.getCenter()
    const northEast = map.getBounds().getNorthEast()
    const borderLocation = eastBorder ? new google.maps.LatLng(center.lat(), northEast.lng()) : new google.maps.LatLng(northEast.lat(), center.lng())

    // compute the distance to the middle of the provided border
    return  google.maps.geometry.spherical.computeDistanceBetween(center, borderLocation)
  } catch (_) {
    // use defaults
    return null
  }
}



// WEBPACK FOOTER //
// ./src/helpers/map/getMapViewportDistance.js